import { z } from "zod";

export const Id = z.uuid();
export const Email = z
  .string()
  .trim()
  .toLowerCase()
  .email({ message: "Bitte eine gültige E-Mail-Adresse eingeben." })
  .max(254);
export const Cent = z.number().int();
export const CentPositiv = z.number().int().min(0);
export const Prozent = z.number().min(0).max(100);
export const Tag = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Datum als YYYY-MM-DD");
export const Slug = z
  .string()
  .trim()
  .toLowerCase()
  .regex(/^[a-z0-9](?:[a-z0-9-]{1,40}[a-z0-9])?$/, "Nur Kleinbuchstaben, Ziffern und Bindestriche");
export const Regalnummer = z.string().regex(/^\d{3}$/, "Regalnummer ist dreistellig, z. B. 055");
export const Mieternummer = z.string().regex(/^\d{4}$/, "Mieternummer ist vierstellig, z. B. 1234");
export const Pin = z.string().regex(/^\d{4,6}$/, "PIN mit 4 bis 6 Ziffern");

export const Rolle = z.enum(["inhaber", "mitarbeiter", "aushilfe"]);
export type Rolle = z.infer<typeof Rolle>;

export const Recht = z.enum([
  "kassieren",
  "rabatt",
  "rabatt_ohne_freigabe",
  "rueckgabe",
  "auszahlung",
  "preise",
  "vertraege",
  "einstellungen",
  "personal",
  "export",
]);
export type Recht = z.infer<typeof Recht>;

/** Feste Rechte-Matrix je Rolle (Plan 3). Inhaber dürfen immer alles. */
export const RECHTE_JE_ROLLE: Record<Rolle, Recht[]> = {
  inhaber: Recht.options,
  mitarbeiter: ["kassieren", "rabatt", "rabatt_ohne_freigabe", "rueckgabe", "auszahlung", "vertraege"],
  aushilfe: ["kassieren", "rabatt"],
};
